<template lang="pug">
.report 
  PageTitle(
    pagetitle="访客地域"
    tip="访客地域报告帮助您了解网站访客的地理分布情况，可以根据不同地区的访问偏好优化网站运营与广告推广")

  CompTimeSpan(
    :type="'normal'",
    :compared="compared",
    @rangeChange="resetCompared",
    @compRangeChange="compRangeChange")

  .zone
    TableTitle(icon="fa fa-signal" title="趋势图")
      .fr
        button.btn.btn-white.btn-small(
          :class="{'btn-primary': currentChart == 'line'}",
          @click="currentChart = 'line'"
          ) 趋势图
        button.btn.btn-white.btn-small(
            :class="{'btn-primary': currentChart == 'map'}",
            :disabled="currentTab == 'city'",
            @click="currentChart = 'map'"
        ) 地图
      div.indices-menu.pull-right(v-if="currentChart == 'map'")
        v-select(
          v-model="customIndice",
          :options="indicesMenu",
          @input="getTop10Data")

      IndiceCompare(
        v-if="currentChart == 'line'",
        :compared="compared",
        :indicesMenu="indicesMenu",
        @indiceChange="indiceChange",
        :indice="customIndice",
        :compIndice="twoIndice",
        :twoIndiceShow="twoIndiceShow")
    table.geo-distrib-charts(v-show="currentChart == 'map'")
      tr
          td(width="50%")
              PieChart(
                  style="border: 0",
                  :legend="provinceLegend",
                  :series="provinceTop10Series",
                  :option="provinPieConf"
              )

          td(width="50%")
              MapChart(
                  style="border: 0",
                  :name="geodistriIndiceName",
                  :series="provinceSeries"
              )
    LineChart(
      v-show="currentChart == 'line'",
      :legend="legend",
      :yAxis= "yAxis",
      v-bind:xAxis="chartXAxis",
      v-bind:series="chartSeries")

  .zone
    TableTitle(icon="fa fa-list" v-bind:title="tableTabTitle")
    div.nav-tabs
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab")
        div.right-tab(slot="extentTab")
          DownloadBtn(
            :reportApi="reportApi",
            :params="query",
            :pagetitle="tableTabTitle",
            subtitle="",
            v-if="total > 0",
            style="float: right")
          CustomIndice(
            :defaults="defaultCustomIndices",
            @change="onCustomIndiceChange")
        div(slot="common") 
          p.plan-nav(v-if="currentTab == 'province'")
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              :options="sdimOptions",
              @change.native="sdimChange")
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
            Search(
              :placeholder="placeHolder",
              @doSearch="doSearch",
              :defaultValue="keyword")
    complex-table(:columns="columns",
      :list="tableDataList",
      :sum="sum",
      :checkbox="hasCheckBox",
      :checkbox_length="checkboxLength",
      :sortKey="order",
      :sortOrder="isasc")
    v-pagination(
      :total="total",
      :pn="pg",
      :ps="ps",
      v-if="total > ps",
      @updatepage="getTableData")
</template>

<script>
  /* global _ */
  import { mapActions } from 'vuex'
  import Store from '../../store/store.js'
  import Table from '../../component/complex-table.vue'
  import Mixin from '../mixin.js'
  import Tool from '../../script/tool.js'
  import { provSimplify } from '../../script/util'
  const indicesDefaults = [
    ['', '请选择指标'],
    ['pv', '浏览量(PV)'],
    ['uv', '访客数(UV)'],
    ['ipnum', 'IP'],
    ['newvst', '新独立访客'],
    ['tnum', '自定义转化次数'],
    ['atime', '平均访问时长']
  ]

export default {
    store: Store,
    components: {
      'complex-table': Table
    },
    mixins: [Mixin],
    data () {
      return {
        geodistriIndice: 'pv',
        provinceTop10Series: [],
        provinceLegend: [],
        provinceSeries: [],
        yAxis: [],
        currentChart: 'map',
        chartResList: [],
        hasCheckBox: false,
        checkboxLength: 3,
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        currentTab: 'province',
        isasc: 0,
        order: 'pv',
        legend: [],
        tablist: [
          {
            id: 'province',
            name: '省份',
            order: 'pv',
            reportTableApi: '/api/report/province?groupby=province',
            basicSummaryStatApi: '/api/report/province?issum=1&groupby=province',
            reportLineChartApi: '/api/report/province?groupby=province'
          },
          {
            id: 'city',
            name: '城市',
            order: 'pv',
            reportTableApi: '/api/report/city?groupby=city',
            basicSummaryStatApi: '/api/report/city?issum=1&groupby=city',
            reportLineChartApi: '/api/report/city?groupby=city'
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        customIndice: 'pv',
        twoIndice: '',
        twoIndiceShow: true,
        compareStart: '',
        compareEnd: '',
        compared: this.$store.state.web.compared,
        sum: {},
        keyword: '',
        tableDataList: [],
        defaultCustomIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
        tableIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
        sdimOptions: []
      }
    },
    computed: {
      geodistriIndiceName () {
        return _.find(this.indicesMenu, {value: this.customIndice}).label
      },
      provinPieConf () {
        return {
          legend: { show: false },
          tooltipFormatter: `${this.geodistriIndiceName}<br>{b}: {c} （{d}%）`,
          labelFormatter: '{b}'
        }
      },
      domainId () {
        return this.$store.state.domainId
      },
      uiError () {
        return this.$store.state.uiError
      },
      fetchLineChartabled () {
        return this.$store.state.tableCheckList.length === 0 || !this.$store.state.drawChartabled
      },
      twoIndiceSelectabled () {
        return this.$store.state.tableCheckList.length > 1
      },
      placeHolder () {
        return `请输入${_.find(this.tablist, {id: this.currentTab}).name}`
      },
      query () {
        let query = {
          isasc: this.isasc,
          order: this.order,
          domainId: this.domainId,
          start: this.$store.state.start,
          end: this.$store.state.end,
          cycle: this.$store.state.start === this.$store.state.end ? 'hour' : 'day',
          timespan: new Date().getTime(),
          mdim: this.currentTab
        }
        if (this.sdim !== 'null') {
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if (this.compared) {
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        if (this.keyword) {
          query = _.assignIn({
            [this.currentTab]: this.keyword
          }, query)
        }
        return query
      },
      reportApi () {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      },

      tableTabTitle () {
        return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
      },
      columns () {
        let columns = [
          {
            title: '分析维度',
            fixed: true,
            children: [
              {
                title: '全网搜索词',
                key: 'name',
                width: 300,
                render: this.textEllipsidRender
              }
            ]
          }
        ]
        const customColumns = [
          {
            title: '基础流量指标',
            children: [
              {
                title: '浏览量(PV)',
                key: 'pv',
                class: 'right',
                sorter: this.sorter,
                render: this.columnRender
              },
              {
                title: '访客数(UV)',
                key: 'uv',
                class: 'right',
                sorter: this.sorter,
                render: this.columnRender
              },
              {
                title: 'IP',
                key: 'ipnum',
                class: 'right',
                sorter: this.sorter,
                render: this.columnRender
              },
              {
                title: '新独立访客',
                key: 'newvst',
                class: 'right',
                sorter: this.sorter,
                render: this.columnRender
              },
              {
                title: '访问次数',
                key: 'vnum',
                class: 'right',
                sorter: this.sorter,
                render: this.columnRender
              }
            ]
          },
          {
            title: '流量质量指标',
            children: [
              {
                title: '平均访问时长',
                key: 'atime',
                class: 'right',
                sorter: this.sorter,
                render: this.atimeRender
              },
              {
                title: '平均访问页数',
                key: 'anum',
                class: 'right',
                sorter: this.sorter,
                render: this.columnRender
              },
              {
                title: '跳出率',
                class: 'right',
                key: 'jrate',
                sorter: this.sorter,
                render: this.percentRender
              }
            ]
          },
          {
            title: '自定义转化指标',
            children: [
              {
                title: '自定义转化次数',
                key: 'tnum',
                class: 'right',
                sorter: this.sorter,
                render: this.columnRender
              },
              {
                title: '转化率',
                key: 'trate',
                class: 'right',
                sorter: this.sorter,
                render: this.percentRender
              }
            ]
          }
        ]
        columns[0].children[0].title = _.find(this.tablist, {id: this.currentTab}).name
  
        const newColumns = _.filter(customColumns, (item) => {
          const newItem = _.filter(item.children, (child) => {
            if (this.tableIndices.includes(child.key)) {
              return child
            }
          })
          item.children = newItem
          if (item.children.length > 0) {
            return item
          }
        })
        columns = _.concat(columns, newColumns)
  
        return columns
      },
      indicesMenu () {
        const indices = [{value: '_', label: '请选择指标'}]
        _.map(this.tableIndices, (item) => {
          indices.push({value: item, label: Tool.getIndexName(item)})
        })
  
        return indices.length > 1 ? indices : indicesDefaults.map(arr => ({key: arr[0], value: arr[1]}))
      },
      start () {
        return this.$store.state.start.replace(/-/g, '/')
      },
      end () {
        return this.$store.state.end.replace(/-/g, '/')
      }
    },
    created () {
      this.getTableData()
      this.getTop10Data()
    },
    watch: {
      domainId () {
        this.clearKeyword()
        this.getTableData()
        this.getTop10Data()
      },
      compared: function (newVal, oldVal) {
        this.compared = newVal
        this.resetIndice()
        if (newVal) {
          this.checkboxLength = 1
        } else {
          this.checkboxLength = 3
        }
      },
      uiError () {
        this.$Modal.warn(this.uiError.errMsg)
      },
      indicesMenu (newVal) {
        const isSameIndice = (a, b) => a === b.value
        let base = _.find(newVal, i => isSameIndice(this.customIndice, i))
        let comp = _.find(newVal, i => isSameIndice(this.twoIndice, i))

        if (base) {
          if (!comp) {
            comp = newVal[0]
          }
        } else {
          base = newVal[1]
          comp = newVal[0]
        }
        this.customIndice = base.value
        this.twoIndice = comp.value
      },
      currentChart (newVal, oldVal) {
        if (newVal === oldVal) return
        this.getTableData()
        this.getTop10Data()
        if (newVal === 'map') {
          this.hasCheckBox = false
        } else {
          this.hasCheckBox = true
        }
      }
    },
    methods: {
      ...mapActions('web', {
        setCompared: 'SET_COMPARED'
      }),
      // 对比时间更新
      compRangeChange ({compared, compStart, compEnd}) {
        this.compared = compared
        this.compareStart = compStart
        this.compareEnd = compEnd
        this.chartResList = []
        this.getTableData()
        this.setCompared({compared: compared, compStart: this.compareStart, compEnd: this.compareEnd})
      },
      // 重置compared并获取数据
      resetCompared () {
        this.compared = false
        this.chartResList = []
        this.getTableData()
        this.getTop10Data()
        this.setCompared({compared: false, compStart: '', compEnd: ''})
      },
      getTop10Data () {
        if (!this.domainId) return
        this.$store.dispatch('SET_CHART_LOADING', true)
        const params = _.assign({ps: 50, pg: 1}, _.pick(this.query, ['cycle', 'start', 'end', 'timespan', 'domainId', 'mdim', 'order', 'isasc', 'groupby']))
        params.order = this.customIndice
        params.isasc = 0
        const allDataPromise = this.$http.get(_.find(this.tablist, {id: this.currentTab}).reportTableApi, { params: params })
        this.$store.dispatch('VUE_HTTP', [allDataPromise])
          .then((res) => {
            if (res) {
              const list = res.list
              const indiceName = this.customIndice

              const totalVal = list.reduce((accu, item) => {
                accu += item[indiceName]
                return accu
              }, 0)
              let top10Val = 0

              // NOTE 必须过滤一下，否则全部为 0 的话会爆栈
              this.provinceSeries = list.map((item, index) => {
                const value = item[indiceName]
                return {
                  province: item.province,
                  name: provSimplify(item.province),
                  value,
                  rate: totalVal ? value / totalVal : 0
                }
              })/* .filter(item => {
                  return item.value > 0;
              }) */
              this.provinceTop10Series = this.provinceSeries.filter((item) => {
                if (item.name !== '其他' && item.name !== '未知') {
                  return item
                }
              }).map((item, index) => {
                if (index < 10) {
                  top10Val += item.value
                  return item
                }
              }).slice(0, 10)
  
              // 获取全集取top10
              this.provinceLegend = this.provinceTop10Series.map(item => {
                return item.province
              })
              if (this.provinceTop10Series.length > 0) {
                this.provinceTop10Series.push({
                  name: '其他',
                  value: totalVal - top10Val,
                  rate: totalVal ? (totalVal - top10Val) / totalVal : 0
                })
              }
              this.$store.dispatch('SET_CHART_LOADING', false)
            }
          })
      },
      onCustomIndiceChange (indices) {
        this.tableIndices = indices
      },
      doSearch: function (keyword) {
        this.keyword = keyword
        this.getTableData()
      },
      updateTab: function (tab) {
        if (this.currentTab === tab) return
        this.resetTab(tab)
        this.keyword = ''
        this.currentChart = this.currentTab === 'province' ? 'map' : 'line'
        this.resetIndice()
        this.getTableData()
      }
    }
  }
</script>
<style scoped>
.geo-distrib-charts {
    width: 100%;
    border-top: 1px solid #e5e5e5;
    padding-top: 10px;
}

.search, .fr {
  float: right;
}
.right-tab a {
  float: left;
}
.fr .btn {
  margin: 0;
}
.fr {
  line-height: 53px;
}
.v-select {
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// geodistrib.vue?49563f1a